/** ループYIELDをスキップするマーク */
export const LOOP_YIELD_SKIP_COMMENT = '@ts-loop-yield-skip';